import { LetterheadForm } from "@/components/agendaTemplate/LetterheadForm";
import { PageHeader } from "@/components/page";
import { useDisableTeam } from "@/components/page/disableTeam";
import { useGetLetterHead } from "@/hooks/queryHooks/letterHeadHooks";
import { useRoleProtected } from "@/hooks/useRoleProtected";
import { Button } from "@repo/ui/components/Base/Button";
import { Spinner } from "@repo/ui/components/Base/Spinner";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

export const LetterHeadPage = () => {
  const { tenantId, letterHeadId } = useParams();
  useRoleProtected("admin");

  useDisableTeam();

  const navigate = useNavigate();

  const [previewOpen, setPreviewOpen] = useState(false);

  const { data: letterHeadData } = useGetLetterHead(
    tenantId ?? "",
    letterHeadId ?? ""
  );

  const handleCancel = () => {
    navigate("..");
  };

  const handleSave = () => {
    navigate("..");
  };

  const create = letterHeadId === "create";

  if (!tenantId) return null;

  return (
    <div className="flex flex-col flex-grow">
      <PageHeader title={create ? "Create Letterhead" : "Edit Letterhead"}>
        <Button onClick={() => setPreviewOpen(true)}>Preview Letterhead</Button>
      </PageHeader>

      {!create && !letterHeadData && <Spinner />}

      <LetterheadForm
        key={letterHeadData?.id ?? "create"}
        tenantId={tenantId}
        letterHeadFormData={letterHeadData ?? undefined}
        previewOpen={previewOpen}
        setPreviewOpen={setPreviewOpen}
        onCancel={handleCancel}
        onSave={handleSave}
      />
    </div>
  );
};
